import { helpEditOrganizationCorpEntities } from '../../app/services/Organization/helpEditOrganization'
import { helpGetAllOrganizationCorpEntities } from '../../app/services/Organization/helpGetAllOrganizationCorpEntities'
import { helpGetTypesOrganization } from '../../app/services/Organization/helpGetTypesOrganization'
import { organizationTypes } from '../constants/action-types'
import { helpGetOrganizationWithCUIT } from '../../app/services/Organization/helpGetOrganizationWithCUIT'
import { helpGetUserForOrganization } from '../../app/services/Organization/helpGetUsersForOrganization'
import { addUserOrganizationCorpEntities } from '../../app/services/Organization/helpAddUserOfOrganization'
import { getDataUserOrganization } from '../../app/services/Organization/getUserDataOrganizationCorpEntities'
import { getOrganizationCommercialUserTypeCorpEntities } from '../../app/services/Organization/getOrganizationCommercialUserTypeCorpEntities'
import { logEvent } from '../../utils/LogEvents'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from './app'
import { helpGetOrganizationWithID } from '../../app/services/Organization/helpGetOrganizationWithID'
import { helpCreateOrganizationCorpEntities } from '../../app/services/Organization/helpCreateOrganization'
import { helpGetTypesUser } from '../../app/services/user/helpgetTypeUser'

export const createOrganization = (organization) => {
  return async (dispatch) => {
    try {
      const response = await helpCreateOrganizationCorpEntities(organization)
      logEvent('CGI - createOrganizationCorpEntities', {
        body: organization,
        response: response
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Organización creada con éxito.'))
    } catch (error) {
      logEvent('CGI - createOrganizationCorpEntities', {
        body: organization,
        error: error
      })
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: OrganizationAPI'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en el servicio:' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      if (error.response?.data?.status === 'Error') {
        return { status: 'error', error: error.response?.data }
      }
      // logEvent('CGI - createOrganizationCorpEntities', {
      //   body: organization,
      //   error: error
      // })
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente.'))
    }
  }
}

export const editOrganization = (organization) => {
  return async (dispatch) => {
    try {
      const response = await helpEditOrganizationCorpEntities(organization)
      logEvent('CGI - updateOrganizationCorpEntities', {
        body: organization,
        response: response
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Organización editada con éxito.'))
    } catch (error) {
      logEvent('CGI - updateOrganizationCorpEntities', {
        body: organization,
        error: error
      })
      // error
      return error
    }
  }
}

// NO
export const addUserOrganization = (user) => {
  return async (dispatch) => {
    try {
      const response = await helpEditOrganizationCorpEntities(user)
      return response
    } catch (error) {
      return error
    }
  }
}

// params for get all orgs
const paramsDefault = {
  organizationTypeCode: 'TESTING-ORG'
}

// get all organizations
export const getAllOrganizations = (params = paramsDefault) => {
  return async (dispatch) => {
    try {
      const response = await helpGetAllOrganizationCorpEntities(params)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: OrganizationApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

// get types of organization
export const getTypesOrganizations = (token = null) => {
  return async (dispatch) => {
    try {
      const response = await helpGetTypesOrganization(token)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: OrganizationApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}

// if ORGANIZATION TYPE WITH ID ORG selected is TESTING ORG permission WRITE READ
// else only permission READ
export const isOrganizationTesting = (organizationId) => {
  return async (dispatch) => {
    try {
      const organization = await dispatch(
        getOrganizationWithID(organizationId)
      )
      const { organizationTypeId } = organization.data?.data
      const types = await dispatch(getTypesOrganizations())
      if (types && types.length > 0 && organizationTypeId) {
        const getType = types.filter(
          (item) => item.organizationTypeCode === 'TESTING-ORG'
        )
        const [typeTesting] = getType
        return organizationTypeId === typeTesting.organizationTypeId
      } else {
        return false
      }
    } catch (error) {
      return false
    }
  }
}
// if ORGANIZATION TYPE CODE selected is TESTING ORG permission WRITE READ
// else only permission READ
export const isOrganizationTestingWithTypeCode = (code) => {
  return async (dispatch) => {
    if (code) {
      const types = await dispatch(getTypesOrganizations())
      if (types && types.length > 0 && code) {
        const getType = types.filter(
          (item) => item.organizationTypeCode === 'TESTING-ORG'
        )
        const [typeTesting] = getType
        return code === typeTesting.organizationTypeId
      } else {
        return false
      }
    } else {
      return false
    }
  }
}

// get type in spanish
export const getTraducTypeOrg = (codeType) => {
  return async (dispatch) => {
    const types = await dispatch(getTypesOrganizations())
    const type = types.filter((type) => type.organizationTypeId === codeType)
    if (type.length > 0) {
      const [typeFilter] = type
      return typeFilter.organizationTypeName
    } else {
      return null
    }
  }
}

export const getOrganizationWithCUIT = (CUIT) => {
  return async (dispatch) => {
    try {
      await helpGetOrganizationWithCUIT(CUIT)
    } catch (error) {
      if (
        error.response?.data?.error.message.includes('Organization not found')
      ) {
        return 'Organization not found'
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente'))
      }
    }
  }
}

// get organization with ID
export const getOrganizationWithID = (organizationId) => {
  return async (dispatch) => {
    try {
      const response = await helpGetOrganizationWithID(organizationId)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: OrganizationApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return null
    }
  }
}

export const getUserForOrganization = (organizationId) => {
  return async (dispatch) => {
    try {
      const response = await helpGetUserForOrganization(organizationId)
      return response.data?.data ? response.data?.data : response
    } catch (error) {
      return 'Error'
    }
  }
}
// NO SE ESTA USANDO
export const adduserForOrganization = (body) => {
  return async (dispatch) => {
    try {
      const response = await addUserOrganizationCorpEntities(body)
      logEvent('CGI - addUserOrganizationCorpEntities', {
        body: body,
        response: response
      })
      return response
    } catch (error) {
      logEvent('CGI - addUserOrganizationCorpEntities', error)

      return error
    }
  }
}

// open modal disable user of suscriber
export const setUserOfSuscriberRequest = () => {
  return {
    type: organizationTypes.ORGANIZATION_SET_USER_OF_SUBSCRIBER_REQUEST
  }
}

export const setUserOfSuscriberSuccess = (suscriber) => {
  return {
    type: organizationTypes.ORGANIZATION_SET_USER_OF_SUBSCRIBER_SUCCESS,
    payload: suscriber
  }
}

export const addNewSearchValueOrg = (value) => {
  return {
    type: organizationTypes.ORGANIZATION_ADD_SEARCH_VALUE_CUIT,
    payload: value
  }
}

export const deleteSearchValueOrg = (value) => {
  return {
    type: organizationTypes.ORGANIZATION_DELETE_SEARCH_VALUE_CUIT,
    payload: value,
  }
}

export const setSearchNameValue = (value) => {
  return {
    type: organizationTypes.ORGANIZATION_SET_SEARCH_NAME_VALUE,
    payload: value,
  }
}

export const deleteSearchNameValue = (value) => {
  return {
    type: organizationTypes.ORGANIZATION_DELETE_SEARCH_NAME_VALUE,
    payload: value,
  }
}
export const setSelectedTypesOrg = (value) => {
  return {
    type: organizationTypes.ORGANIZATION_SET_SELECTED_TYPES_ORG,
    payload: value,
  }
}
// get data user organization
export const getDataUserOrganizationID = (organizationUserId) => {
  return async (dispatch) => {
    try {
      const response = await getDataUserOrganization(organizationUserId)
      return response.data
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error. Intente nuevamente'))
      return 'Error'
    }
  }
}

// get user commercial type
export const getOrganizationCommercialUserType = () => {
  return async (dispatch) => {
    try {
      const response = await getOrganizationCommercialUserTypeCorpEntities()
      return response.data
    } catch (error) {
      return 'Error'
    }
  }
}

// get types user of subscriber
export const getTypesUser = () => {
  return async (dispatch) => {
    try {
      const types = await helpGetTypesUser()
      return types.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: OrganizationApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return []
    }
  }
}
